import DirectioNewsList from './directioNewsList';

export default DirectioNewsList;



/** WEBPACK FOOTER **
 ** ./Scripts/libs/components/DirectioNewsList/index.js
 **/